<template>
  <footer v-if="isBarShow" v-show="isScreenCapture" class="resultv2_function_bar function-bar">
    <div class="function-inner">
      <template v-if="isTrades">
        <template v-if="bApp">
          <div
            v-if="isSupportRecordScreen && recordingState"
            class="function-hd"
          >
            <name-card :name-card-infor="data" />
          </div>
          <btn-layer
            :is-policy-check="isPolicyCheck"
            :is-scheme-show="isSchemeShow"
            :is-trade="true"
            @invoke="handleInvoke"
          />
        </template>
        <template v-else>
          <a
            key="ljtb"
            class="btn insured"
            :href="
              dataTrade0.productInfo &&
                dataTrade0.productInfo.shareTradeUrl
            "
            data-stat-id="lktb"
            :data-stat-ep="
              JSON.stringify({
                cpId: dataTrade0.productInfo.tradeId,
              })
            "
          >立即投保</a>
        </template>
      </template>
      <template v-else-if="isSaShow || isGaokeAgent">
        <div v-if="isSaShow && isSupportRecordScreen && recordingState" class="function-hd">
          <name-card :name-card-infor="data" />
        </div>
        <btn-layer
          :is-gaoke-agent="isGaokeAgent"
          :is-policy-check="isPolicyCheck"
          :is-scheme-show="isSchemeShow"
          :is-trade="false"
          :is-show-theme-picker="!isGaokeAgent && isBxs && !isPolicyCheck"
          @invoke="handleInvoke"
        />
      </template>
    </div>
    <ExportImagesPopup
      v-model="popConfig.visible"
      :scene="3"
      :plain-result-data="plainResultData"
      :liability-show-type="liabilityShowType"
      :interest-data="interestData"
      :theme-settings="themeSettings"
      @openThemePicker="$emit('openThemePicker')"
      @openInterestSettingPopup="$emit('openInterestSettingPopup')"
      @screen-capture="screenCapture"
    />
    <!-- 2024-04-01T00:00:00 以后，可删除引导 -->
    <div
      v-if="isShowInterestExportGuide && (!!interestData || (interestExportGuideStep === 3))"
      class="interest_export_guide"
      @click.stop="onClickInterestExportGuide"
    >
      <img v-if="interestExportGuideStep === 1" class="step1" src="https://media.winbaoxian.com/assets-uploader/Group%402x-1706868842388.png">
      <img v-if="interestExportGuideStep === 2" class="step2" src="https://media.winbaoxian.com/assets-uploader/%E7%94%BB%E6%9D%BF%E5%A4%87%E4%BB%BD%203-1706059670351.png">
      <img v-if="interestExportGuideStep === 3" class="step3" src="https://media.winbaoxian.com/assets-uploader/Group%203%402x-1706868842388.png">
    </div>
  </footer>
</template>
<script>
import Cookies from 'js-cookie'
import { mapState } from 'vuex'
import QS from 'qs'
import { reg } from 'api/config'
import { bApp, isBxs, isWeCom } from 'base/config'
import { URL_PARAM } from '@/utils/variables.js'
import { showTopArrow } from '../../js/handler'

import NameCard from '@/components/footer/nameCard.vue'
import BtnLayer from '@/components/footer/childComponents/btnLayer.vue'
import ExportImagesPopup from '../exportImages/popup.vue'

const INTEREST_EXPORT_GUIDE_EXPIRY_TIMESTAMP = new Date('2024-04-01T00:00:00').getTime()
export default {
  components: {
    NameCard,
    BtnLayer,
    ExportImagesPopup
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    liabilityShowType: {
      type: Number,
      default: 0
    },
    plainResultData: {
      type: Object,
      default: () => ({})
    },
    themeSettings: {
      type: Object,
      default: () => ({})
    },
    isSupportRecordScreen: {
      type: Boolean,
      default: false
    },
    isScreenCapture: {
      type: Boolean,
      default: false
    },
    isForPresentation: {
      type: Boolean,
      default: false
    },
    isTrades: {
      type: Boolean,
      default: false
    },
    recordingState: {
      type: Boolean,
      default: false
    },
    isPolicyCheck: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      popConfig: {
        visible: false
      },
      bApp,
      isBxs,
      isGaokeAgent: URL_PARAM.page_form === 'crm' && URL_PARAM.page_crm !== 'customer',
      isShowInterestExportGuide: false,
      interestExportGuideStep: 1
    }
  },
  computed: {
    ...mapState({
      interestData: 'interestData'
    }),
    isBarShow () {
      // 高客公众号：代理人
      if (this.isPolicyCheck && URL_PARAM.page_form === 'crm') {
        return this.isGaokeAgent
      }
      // 保单年检，c端 && 单个交易产品，不显示<投保按钮> => 不显示foot
      if (this.isPolicyCheck) {
        return !(this.isTrades && !bApp)
      }
      return (bApp || this.isTrades || isWeCom) && !this.isForPresentation
    },
    isSchemeShow () {
      return !this.recordingState
    },
    isSaShow () {
      return bApp || isWeCom
    },
    trade0ProductInfo () {
      return this.data && this.data.trades && this.data.trades[0] && this.data.trades[0].productInfo
    }
  },
  created() {
    const step = Cookies.get('INTEREST_EXPORT_GUIDE_STEP')
    if (new Date() < INTEREST_EXPORT_GUIDE_EXPIRY_TIMESTAMP) {
      if (!step) {
        this.isShowInterestExportGuide = true
      } else if (Number(step) < 3) {
        this.interestExportGuideStep = 3
        this.isShowInterestExportGuide = true
      }
    }
  },
  methods: {
    jumpTo (url) {
      if (!url) return
      location.href = url
    },
    handleInvoke (type) {
      const { isGaokeAgent, isPolicyCheck, trade0ProductInfo } = this
      // 交易-立即投保
      if (type === 'insured') {
        if (trade0ProductInfo) {
          window.WeiyiStatSDK.submit('lktb', {
            cpId: trade0ProductInfo.tradeId
          })
          this.jumpTo(trade0ProductInfo.tradeUrl)
        }
        return
      }

      // 保单年检保存
      if (type === 'save') {
        if (isPolicyCheck) {
          const params = {
            nw: 1,
            cid: URL_PARAM.familyhead
          }
          if (isGaokeAgent) {
            params.nw = undefined
            params.page_form = URL_PARAM.page_form
          }
          this.jumpTo(`https://policy-inspection.winbaoxian.${reg ? 'com' : 'cn'}/annualSurvey/family-policy.html?${QS.stringify(params)}`)
        }
        return
      }

      // 高客-保单托管
      if (type === 'share' && isGaokeAgent) {
        showTopArrow()
        return
      }
      // 企微-引导分享
      if (type === 'share' && isWeCom && window.WeCom && WeCom.showTopArrow) {
        WeCom.showTopArrow()
        return
      }

      // 新版导出图片，依赖版本@7.23.0
      if (type === 'generate-image') {
        this.popConfig = {
          visible: true
        }
        window.WeiyiStatSDK.submit('JGY_TPYL_V2', {
          scene: 3
        })
        const step = Cookies.get('INTEREST_EXPORT_GUIDE_STEP') || 0
        if (step < 2 && new Date() < INTEREST_EXPORT_GUIDE_EXPIRY_TIMESTAMP) {
          this.interestExportGuideStep = 2
          this.isShowInterestExportGuide = true
        }
        return
      }

      // 同屏讲解
      if (type === 'interpretation') {
        window.WeiyiStatSDK.submit('jiangjie')
      }

      this.$emit(type)
    },
    screenCapture(done) {
      this.$emit('screen-capture', done)
    },
    onClickInterestExportGuide () {
      const dayCount = Math.ceil((INTEREST_EXPORT_GUIDE_EXPIRY_TIMESTAMP - new Date()) / 1000 / 3600 / 24)
      Cookies.set(`INTEREST_EXPORT_GUIDE_STEP`, this.interestExportGuideStep, { expires: dayCount })
      this.isShowInterestExportGuide = false
    }
  }
}
</script>

<style>
  @import './index.css';
</style>
